import { render, staticRenderFns } from "./BookingCalendarMonthDesktopHeader.vue?vue&type=template&id=3f670e62"
import script from "./BookingCalendarMonthDesktopHeader.vue?vue&type=script&lang=js"
export * from "./BookingCalendarMonthDesktopHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports